import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('ziyaretciler');
  const [ziyaretciler, setZiyaretciler] = useState([]);
  const [birimler, setBirimler] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Form states
  const [birimForm, setBirimForm] = useState({ birim_adi: '' });
  const [personelForm, setPersonelForm] = useState({ ad_soyad: '', gorev: '', birim_id: '' });
  const [userForm, setUserForm] = useState({ username: '', password: '', email: '', role: 'user' });
  
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab === 'ziyaretciler') {
      fetchZiyaretciler();
    } else if (activeTab === 'birimler') {
      fetchBirimler();
    } else if (activeTab === 'personeller') {
      fetchPersoneller();
      fetchBirimler();
    } else if (activeTab === 'kullanicilar') {
      fetchUsers();
    }
  }, [activeTab]);

  const fetchZiyaretciler = async () => {
    setLoading(true);
    try {
      const response = await api.get('/ziyaretciler');
      setZiyaretciler(response.data);
    } catch (error) {
      console.error('Ziyaretçiler yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBirimler = async () => {
    try {
      const response = await api.get('/birimler');
      setBirimler(response.data);
    } catch (error) {
      console.error('Birimler yüklenemedi:', error);
    }
  };

  const fetchPersoneller = async () => {
    try {
      const response = await api.get('/personeller');
      setPersoneller(response.data);
    } catch (error) {
      console.error('Personeller yüklenemedi:', error);
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get('/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Kullanıcılar yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCikis = async (id) => {
    if (window.confirm('Çıkış zamanı kaydedilsin mi?')) {
      try {
        await api.put(`/ziyaretciler/${id}/cikis`);
        fetchZiyaretciler();
        alert('Çıkış zamanı kaydedildi');
      } catch (error) {
        alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
      }
    }
  };

  const handleDeleteZiyaretci = async (id) => {
    if (window.confirm('Bu ziyaretçi kaydı silinsin mi?')) {
      try {
        await api.delete(`/ziyaretciler/${id}`);
        fetchZiyaretciler();
        alert('Kayıt silindi');
      } catch (error) {
        alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
      }
    }
  };

  const handleAddBirim = async (e) => {
    e.preventDefault();
    try {
      await api.post('/birimler', birimForm);
      setBirimForm({ birim_adi: '' });
      fetchBirimler();
      alert('Birim eklendi');
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
    }
  };

  const handleDeleteBirim = async (id) => {
    if (window.confirm('Bu birim silinsin mi?')) {
      try {
        await api.delete(`/birimler/${id}`);
        fetchBirimler();
        alert('Birim silindi');
      } catch (error) {
        alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
      }
    }
  };

  const handleAddPersonel = async (e) => {
    e.preventDefault();
    try {
      await api.post('/personeller', personelForm);
      setPersonelForm({ ad_soyad: '', gorev: '', birim_id: '' });
      fetchPersoneller();
      alert('Personel eklendi');
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
    }
  };

  const handleDeletePersonel = async (id) => {
    if (window.confirm('Bu personel silinsin mi?')) {
      try {
        await api.delete(`/personeller/${id}`);
        fetchPersoneller();
        alert('Personel silindi');
      } catch (error) {
        alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
      }
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    try {
      await api.post('/users', userForm);
      setUserForm({ username: '', password: '', email: '', role: 'user' });
      fetchUsers();
      alert('Kullanıcı eklendi');
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
    }
  };

  const handleDeleteUser = async (id) => {
    if (window.confirm('Bu kullanıcı silinsin mi?')) {
      try {
        await api.delete(`/users/${id}`);
        fetchUsers();
        alert('Kullanıcı silindi');
      } catch (error) {
        alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('tr-TR');
  };

  return (
    <div className="container">
      <div className="nav">
        <button onClick={() => navigate('/form')} className="btn btn-secondary">
          ← Ana Sayfa
        </button>
        <button onClick={() => setActiveTab('ziyaretciler')} className="btn btn-secondary">
          Ziyaretçiler
        </button>
        <button onClick={() => setActiveTab('birimler')} className="btn btn-secondary">
          Birimler
        </button>
        <button onClick={() => setActiveTab('personeller')} className="btn btn-secondary">
          Personeller
        </button>
        <button onClick={() => setActiveTab('kullanicilar')} className="btn btn-secondary">
          👥 Kullanıcılar
        </button>
        <button onClick={() => navigate('/admin/rapor')} className="btn btn-secondary">
          Raporlar
        </button>
        <button onClick={() => navigate('/admin/grafik')} className="btn btn-secondary">
          Grafikler
        </button>
        <button onClick={handleLogout} className="btn btn-primary">
          Çıkış Yap
        </button>
      </div>

      <div className="card">
        {activeTab === 'ziyaretciler' && (
          <>
            <h2 style={{ color: '#ff0000' }}>Ziyaretçi Listesi</h2>
            {loading ? (
              <div className="loading">Yükleniyor...</div>
            ) : (
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Ad Soyad</th>
                      <th>Firma</th>
                      <th>Ziyaret Türü</th>
                      <th>Araç/Plaka</th>
                      <th>Birim</th>
                      <th>Personel</th>
                      <th>Geliş</th>
                      <th>Çıkış</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ziyaretciler.map(z => (
                      <tr key={z.id}>
                        <td>{z.ad_soyad}</td>
                        <td>{z.firma_adi || '-'}</td>
                        <td>{z.ziyaret_turu}</td>
                        <td>{z.arac_var ? z.plaka : 'Yok'}</td>
                        <td>{z.birim_adi || '-'}</td>
                        <td>{z.personel_adi || '-'}</td>
                        <td>{formatDate(z.gelis_zamani)}</td>
                        <td>{formatDate(z.cikis_zamani)}</td>
                        <td>
                          {!z.cikis_zamani && (
                            <button 
                              onClick={() => handleCikis(z.id)} 
                              className="btn btn-secondary"
                              style={{ fontSize: '12px', padding: '5px 10px' }}
                            >
                              Çıkış
                            </button>
                          )}
                          <button 
                            onClick={() => handleDeleteZiyaretci(z.id)} 
                            className="btn btn-primary"
                            style={{ fontSize: '12px', padding: '5px 10px' }}
                          >
                            Sil
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}

        {activeTab === 'birimler' && (
          <>
            <h2 style={{ color: '#ff0000' }}>Birim Yönetimi</h2>
            
            <form onSubmit={handleAddBirim} style={{ marginBottom: '30px' }}>
              <div className="form-group">
                <label>Yeni Birim Ekle</label>
                <input
                  type="text"
                  value={birimForm.birim_adi}
                  onChange={(e) => setBirimForm({ birim_adi: e.target.value })}
                  placeholder="Birim adı"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary">Ekle</button>
            </form>

            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Birim Adı</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {birimler.map(b => (
                    <tr key={b.id}>
                      <td>{b.birim_adi}</td>
                      <td>
                        <button 
                          onClick={() => handleDeleteBirim(b.id)} 
                          className="btn btn-primary"
                          style={{ fontSize: '12px', padding: '5px 10px' }}
                        >
                          Sil
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {activeTab === 'personeller' && (
          <>
            <h2 style={{ color: '#ff0000' }}>Personel Yönetimi</h2>
            
            <form onSubmit={handleAddPersonel} style={{ marginBottom: '30px' }}>
              <div className="form-group">
                <label>Ad Soyad</label>
                <input
                  type="text"
                  value={personelForm.ad_soyad}
                  onChange={(e) => setPersonelForm({ ...personelForm, ad_soyad: e.target.value })}
                  placeholder="Personel adı soyadı"
                  required
                />
              </div>
              <div className="form-group">
                <label>Görevi</label>
                <input
                  type="text"
                  value={personelForm.gorev}
                  onChange={(e) => setPersonelForm({ ...personelForm, gorev: e.target.value })}
                  placeholder="Görevi"
                />
              </div>
              <div className="form-group">
                <label>Birimi</label>
                <select
                  value={personelForm.birim_id}
                  onChange={(e) => setPersonelForm({ ...personelForm, birim_id: e.target.value })}
                  required
                >
                  <option value="">-- Birim Seçin --</option>
                  {birimler.map(b => (
                    <option key={b.id} value={b.id}>{b.birim_adi}</option>
                  ))}
                </select>
              </div>
              <button type="submit" className="btn btn-primary">Ekle</button>
            </form>

            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Ad Soyad</th>
                    <th>Görevi</th>
                    <th>Birimi</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {personeller.map(p => (
                    <tr key={p.id}>
                      <td>{p.ad_soyad}</td>
                      <td>{p.gorev || '-'}</td>
                      <td>{p.birim_adi || '-'}</td>
                      <td>
                        <button 
                          onClick={() => handleDeletePersonel(p.id)} 
                          className="btn btn-primary"
                          style={{ fontSize: '12px', padding: '5px 10px' }}
                        >
                          Sil
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {activeTab === 'kullanicilar' && (
          <>
            <h2 style={{ color: '#ff0000' }}>👥 Kullanıcı Yönetimi</h2>
            
            <form onSubmit={handleAddUser} style={{ marginBottom: '30px' }}>
              <div className="form-group">
                <label>Kullanıcı Adı *</label>
                <input
                  type="text"
                  value={userForm.username}
                  onChange={(e) => setUserForm({ ...userForm, username: e.target.value })}
                  placeholder="Kullanıcı adı"
                  required
                />
              </div>
              <div className="form-group">
                <label>Şifre *</label>
                <input
                  type="password"
                  value={userForm.password}
                  onChange={(e) => setUserForm({ ...userForm, password: e.target.value })}
                  placeholder="Şifre"
                  required
                />
              </div>
              <div className="form-group">
                <label>E-posta</label>
                <input
                  type="email"
                  value={userForm.email}
                  onChange={(e) => setUserForm({ ...userForm, email: e.target.value })}
                  placeholder="E-posta adresi"
                />
              </div>
              <div className="form-group">
                <label>Yetki</label>
                <select
                  value={userForm.role}
                  onChange={(e) => setUserForm({ ...userForm, role: e.target.value })}
                >
                  <option value="user">Normal Kullanıcı</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
              <button type="submit" className="btn btn-primary">Kullanıcı Ekle</button>
            </form>

            {loading ? (
              <div className="loading">Yükleniyor...</div>
            ) : (
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Kullanıcı Adı</th>
                      <th>E-posta</th>
                      <th>Yetki</th>
                      <th>Kayıt Tarihi</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map(u => (
                      <tr key={u.id}>
                        <td>{u.username}</td>
                        <td>{u.email || '-'}</td>
                        <td>
                          <span style={{ 
                            backgroundColor: u.role === 'admin' ? '#ff0000' : '#666',
                            color: '#fff',
                            padding: '3px 8px',
                            borderRadius: '3px',
                            fontSize: '12px'
                          }}>
                            {u.role === 'admin' ? '👑 Admin' : '👤 User'}
                          </span>
                        </td>
                        <td>{formatDate(u.created_at)}</td>
                        <td>
                          {u.role !== 'admin' && (
                            <button 
                              onClick={() => handleDeleteUser(u.id)} 
                              className="btn btn-primary"
                              style={{ fontSize: '12px', padding: '5px 10px' }}
                            >
                              Sil
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
